export default {"src":"/_next/static/media/white-audio-tour-icon.3c4c6a35.svg","height":15,"width":17,"blurWidth":0,"blurHeight":0};